import { toast } from "react-toastify";


export const errorToast = (error, message, t) => {
    if (error?.response?.data?.msg === "Token has expired") {
        toast.error(t("general.loginEXP"));
        setTimeout(()=>{
            localStorage.clear(); 
            window.location.reload();
        }, 500)
    } else if (error?.status === 404) {
        toast.error(t("general.formNotFound"));
    } else {
        toast.error(message);
    }
}